<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <transition name="fade">
          <b-card no-body>
            <div class="card-smallHeader card-header-action" v-b-toggle.collapseDetail>
              <strong> Critères de la Campagne : <span style="color: #C52C95"> {{ libelle }} </span></strong>
              <div class="card-header-actions">
                    <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
              </div>
            </div>
            <b-collapse id="collapseDetail">
              <b-card-body>
                <b-card no-body>
                <b-row>
                  <b-col sm="12">
                    <div class="card-smallHeader card-header-action mb-2">
                      <span style="color: #d9418b" class="mr-2"><b>Informations Campagne</b></span>
                    </div>
                  </b-col>
                </b-row>
                  <b-row style="margin-left: 5px;margin-right: 5px;">
                    <b-col sm="4" class="border-right">
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Motif de l'opération</strong></template>
                        <b-form-select v-model="motif_op" :options="motifsControle" disabled>
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Type de contrôle</strong></template>
                        <b-form-select v-model="type_controle" :options="typesControle" disabled>
                        </b-form-select>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Descriptif</strong></template>
                        <b-form-textarea id="descriptif" type="text" rows="3" max-rows="6" v-model="descriptif" disabled>
                        </b-form-textarea>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4" class="border-right">
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Valideur</strong></template>
                        <b-form-input
                          id="valideur"
                          v-model="gestionnaire"
                          item-value="id"
                          item-text="nom"
                          disabled>
                        </b-form-input>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Demandeur</strong></template>
                        <b-form-input id="demandeur" type="text" v-model="demandeur" disabled></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Echantillon annuel</strong></template>
                        <b-form-input id="echantillon_annuel" type="number" v-model="echantillonAnnuel"
                                      disabled></b-form-input>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Fréquence</strong></template>
                        <b-form-input id="frequence" type="text" v-model="frequence" disabled></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
               
 
                <b-card no-body>
                 <b-row>
                    <b-col sm="12">
                      <div class="card-smallHeader card-header-action mb-2">
                        <span style="color: #d9418b" class="mr-2"><b>Critères Dossiers</b></span>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row style="margin-left: 5px;margin-right: 5px;">
                    <b-col sm="4" class="border-right">
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Date réception du</strong></template>
                        <b-form-input type="date" v-model="date_du" disabled></b-form-input>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Date réception au</strong></template>
                        <b-form-input type="date" v-model="date_au" disabled></b-form-input>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Traitement</strong></template>
                        <b-form-select v-model="traitementId" :options="traitementsOptions" disabled>
                        </b-form-select>
                      </b-form-group>
                      <div v-if="displayDateSinistre">
                        <b-form-group :horizontal="true" :label-cols="3">
                          <template slot="label"><strong>Date sinistre du</strong></template>
                          <b-form-input type="date" v-model="date_sinistre_du" disabled></b-form-input>
                        </b-form-group>
                        <b-form-group :horizontal="true" :label-cols="3">
                          <template slot="label"><strong>Date sinistre au</strong></template>
                          <b-form-input type="date" v-model="date_sinistre_au" disabled></b-form-input>
                        </b-form-group>
                      </div>
                      <!-- <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>NIR</strong></template>
                        <b-form-input type="text" v-model="nir" disabled></b-form-input>
                      </b-form-group> -->
                      <b-row class="mb-1">
                        <b-col sm="2">
                          <label for="nir" style="margin-top: 10px"><strong>NIR :</strong></label>
                        </b-col>
                        <b-col sm="4">
                            <b-form-input type="text" id="nir" v-model="nir" placeholder="Commence par..." disabled></b-form-input>
                        </b-col>
                        <b-col sm="2">
                          <label for="idpp" style="margin-top: 10px"><strong>IDPP :</strong></label>
                        </b-col>
                        <b-col sm="4">
                            <b-form-input type="text" id="idpp" v-model="idpp" placeholder="N° NSI" disabled></b-form-input>
                        </b-col>
                      </b-row>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Siren</strong></template>
                        <b-form-input type="text" v-model="siren"
                                      disabled></b-form-input>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Canal</strong></template>
                        <multiselect id="canal" :close-on-select="false"
                                     v-model="canal" label="name" track-by="code"
                                     :options="allCanals" :multiple="true" :taggable="true" disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Flag</strong></template>
                        <multiselect 
                              :close-on-select="false" 
                              v-model="flag" 
                              label="name" 
                              track-by="code" 
                              :options="flagOptionsWithAdmin" 
                              :multiple="true" 
                              :taggable="true" disabled>
                            </multiselect>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4" class="border-right">
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Segment</strong></template>
                        <multiselect id="segment" :close-on-select="false"
                                     v-model="segment" label="name" track-by="code"
                                     :options="allSegments" :multiple="true" :taggable="true" disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Type</strong></template>
                        <multiselect id="type" :close-on-select="false"
                                     v-model="type" label="name" track-by="code" :options="allTypes"
                                     :multiple="true" :taggable="true" disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Statut dossier</strong></template>
                        <multiselect id="statut_dossier" :close-on-select="false"
                                     v-model="status" label="name" track-by="code"
                                     :options="allStatusOption" :multiple="true" :taggable="true"
                                     disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Sous Statut</strong></template>
                        <multiselect id="sous_statut_dossier" :close-on-select="false"
                                     v-model="sousStatus" label="name" track-by="code"
                                     :options="allSousStatusOption" :multiple="true" :taggable="true"
                                     disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Statut Prest'IJ</strong></template>
                        <multiselect id="statut_prestij"
                                     :close-on-select="false"
                                     v-model="statusPrestij"
                                     label="name"
                                     track-by="code"
                                     :options="allStatusPrestij"
                                     :multiple="true"
                                     :taggable="true"
                                     disabled>
                        </multiselect>
                      </b-form-group>
                      <b-row class="mb-1">
                        <b-col sm="3" style="margin-top: 10px">
                          <label><strong>Groupe Siren :</strong></label>
                        </b-col>
                        <b-col sm="6">
                          <multiselect :close-on-select="false"
                                      v-model="groupSirens"
                                      label="name"
                                      track-by="code"
                                      :options="allGroupSirens"
                                      :multiple="true"
                                      :taggable="true"
                                      disabled>
                          </multiselect>
                        </b-col>
                        <b-col sm="3" style="margin-top:10px;">
                          <span style="display:table-cell;vertical-align:middle;">
                            <strong style="margin-right: 10px">exclus</strong>
                          </span>
                          <span style="display:table-cell;vertical-align:middle;">
                            <b-form-checkbox v-model="exclureGroupeSiren" style="margin-right: 10px"></b-form-checkbox>
                          </span>
                        </b-col>
                      </b-row>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Famille produit</strong></template>
                        <multiselect id="famille_produit" :close-on-select="false"
                                     v-model="produit" label="name" track-by="code"
                                     :options="allProduits" :multiple="true" :taggable="true"
                                     disabled>
                        </multiselect>
                      </b-form-group>
                  </b-col>
                  <b-col sm="4" class="border-right">
                      <b-form-group :horizontal="true" :label-cols="3" label="Gestionnaire affecté" label-for="gestionnaire_affecte">
                        <b-form-input
                          id="gestionnaire_affecte"
                          v-model="gestionnaire_affecte"
                          item-value="id"
                          item-text="nom"
                          disabled>
                        </b-form-input>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Equipe habilitée</strong></template>
                              <b-form-select v-model="equipes" :options="allEquipesOption" disabled>
                              </b-form-select>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Segment Commercial</strong></template>
                        <multiselect id="segment_commercial"
                                     :close-on-select="false"
                                     v-model="segmentsCommerciaux"
                                     label="name"
                                     track-by="code"
                                     :options="allSegmentsCommerciaux"
                                     :multiple="true"
                                     :taggable="true"
                                     disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Délégation Commerciale</strong></template>
                        <multiselect id="delegation_commerciale"
                                     :close-on-select="false"
                                     v-model="delegations"
                                     label="name"
                                     track-by="code"
                                     :options="allDelegations"
                                     :multiple="true"
                                     :taggable="true"
                                     disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>OAG</strong></template>
                        <multiselect :close-on-select="false"
                                     v-model="oags"
                                     label="name"
                                     track-by="code"
                                     id="oag"
                                     :options="oagOptions" :multiple="true"
                                     :taggable="true"
                                     disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label">OAP</template>
                        <multiselect :close-on-select="false"
                                   v-model="oaps"
                                   label="name"
                                   track-by="code"
                                   id="oap"
                                   :options="oapOptions" :multiple="true"
                                   :taggable="true"
                                   disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Type Urgence</strong></template>
                        <multiselect id="typeUrgence" :close-on-select="false"
                                     v-model="typeUrgence" label="name" track-by="code"
                                     :options="allTypesUrgences" :multiple="true" :taggable="true" disabled>
                        </multiselect>
                      </b-form-group>
                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Règle de cumul</strong></template>
                              <b-form-select v-model="regleCumul" :options="allRegleCumulOption" disabled>
                              </b-form-select>
                      </b-form-group>

                      <b-form-group :horizontal="true" :label-cols="3">
                        <template slot="label"><strong>Dossiers ouverts par NIR : </strong></template>
                            <b-form-input style="width:150px; display:table-cell;vertical-align:middle;margin-right: 10px;" v-model="nbDossierNir" id="nbDossierNir" type="range" min="0" max="50" step="5" disabled>
                            </b-form-input>
                            <span style="display:table-cell;vertical-align:middle;">
                              <b-badge style="margin-right: 20px" pill variant="success">{{ displayNbDossierNir() }}</b-badge>
                            </span>
                            <span style="display:table-cell;vertical-align:middle;">
                              <strong style="margin-right: 10px">hors BPIJ</strong>
                            </span>
                             <span style="display:table-cell;vertical-align:middle;">
                              <b-form-checkbox v-model="exclureBpij" style="margin-right: 10px" disabled></b-form-checkbox>
                            </span>
                      </b-form-group>
                      <b-row class="mb-1">
                        <b-form-group style="margin-left: 15px">
                          <label for="date_traitement">Date changement statut </label>
                          <b-row>
                            <b-col sm="4">
                              <b-form-input type="date" v-model="dateTraitement" disabled></b-form-input>
                            </b-col>
                            <b-col sm="8">
                              <b-form-select v-model="traitementStatusId" :options="traitementsOptions" disabled>
                              </b-form-select>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <transition name="fade">
          <b-card no-body>
            <div class="card-smallHeader card-header-action" v-b-toggle.collapseStats>
              <strong>Suivi de campagne</strong>
              <div class="card-header-actions">
                <span class="when-opened">
                  <i class="icon-arrow-down"></i>
                </span>
                <span class="when-closed">
                  <i class="icon-arrow-up"></i>
                </span>
              </div>
            </div>
            <b-collapse id="collapseStats">
              <b-card-body class="small-padding">
                <b-row>
                  <b-col md="6">
                    <b-row>
                      <b-col md="6"><span>Nombre de dossier dans la campagne : </span></b-col>
                      <b-col md="6">{{ stats.nbr_dossiers }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6"><span>Nombre de dossiers à affecter : </span></b-col>
                      <b-col md="6">{{ stats.nbr_dossiers_a_affecter }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6"><span>Nombre de dossiers en cours : </span></b-col>
                      <b-col md="6">{{ stats.nbr_dossiers_en_cours }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6"><span>Nombre de dossiers contrôlés : </span></b-col>
                      <b-col md="6">{{ stats.nbr_dossiers_traites
                        }} (dont {{stats.nbr_dossiers_abandonnes}} abandonnés)
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="6">
                    <b-row>
                      <b-col md="6"><span>Nombre de dossier conforme : </span></b-col>
                      <b-col md="6">{{ stats.nbr_dossiers_ok }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6"><span>Nombre de dossier non conforme : </span></b-col>
                      <b-col md="6">{{ stats.nbr_dossiers_ko }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6"><a href="#" @click.prevent="repartitionMotifsNonConforme()">Répartition des motifs non conforme</a>
                      </b-col>
                      <b-col md="6"></b-col>
                    </b-row>
                    <b-row>
                      <b-col md="6"><a href="#" @click.prevent="NbrDossiersEnAnomalieParCollaborateur()">Nombre de dossiers en anomalie par collaborateur</a>
                      </b-col>
                      <b-col md="6"></b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <transition name="fade">
          <b-card no-body>
            <div class="card-smallHeader card-header-action" v-b-toggle.collapseAttachedDossiers>
              <strong>Dossiers Attachés</strong>
              <div class="card-header-actions">
                    <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
              </div>
            </div>
            <b-collapse id="collapseAttachedDossiers" :visible="true">
              <b-card-body class="small-padding">
                <v-server-table @loaded="onLoaded" ref="attached_dossiers_table" :columns="columns" :url="url"
                                :options="options"
                                style="overflow: hidden;">
                  <div slot="source" slot-scope="props">
                    <b>{{ props.row.id }}</b> <br> {{ props.row.canal.libelle }}
                  </div>
                  <div slot="date_reception" slot-scope="props" v-html="formatDate(props.row.date_reception)">
                  </div>
                  <div slot="dossier_type" slot-scope="props">
                    <span>{{ props.row.type ? props.row.type.libelle : 'n.d' }}</span><br>
                    <span v-b-tooltip.hover
                          :title="getLibelleTraitement(props.row,'long')">{{ getLibelleTraitement(props.row, 'court')
                      }}</span>
                  </div>
                  <div slot="siren" slot-scope="props">
                    <!-- <b
                      style="color: rgb(217, 65, 139);">{{ props.row.siren ? props.row.siren.siren : 'n.d'}} (OAG {{props.row.oag}} OAP {{props.row.oap}})</b><br> -->
                      <b style="color: rgb(217, 65, 139);">{{ props.row.siren ? props.row.siren.siren : 'n.d' }} (OAG </b><b style="color: #ff0032;">{{ props.row.oag }}</b>
                      <b style="color: rgb(217, 65, 139);">  OAP</b><b style="color: #ffa434;"> {{ props.row.oap }}</b><b style="color: rgb(217, 65, 139);">)</b><br>
                    <span class="text-success" :id="`tooltip-rs-${props.row.id}`">
                      {{ props.row.siren ? (props.row.siren.raison_sociale.length > 42 ? props.row.siren.raison_sociale.substring(0, 39) + '...' : props.row.siren.raison_sociale) : 'n.d'}}
                    </span>
                    <b-tooltip v-if="props.row.siren && props.row.siren.raison_sociale.length > 45"
                               :target="`tooltip-rs-${props.row.id}`" triggers="hover" placement="top">
                      {{ props.row.siren.raison_sociale }}
                    </b-tooltip>
                  </div>
                  <div slot="produit" slot-scope="props" v-html="getInfosSegmentProduit(props.row)">
                  </div>
                  <div v-if="getHabilitation(props.row)" slot="nom" slot-scope="props">
                    <b style="color: #990000;">{{ props.row.nir ? formatNir(props.row.nir) : 'n.d' }} ({{ props.row.id_pp}})</b><br>
                    <span class="">{{ props.row.nom ? props.row.nom.toUpperCase() + ' ' + props.row.prenom : 'n.d'
                      }}</span>
                  </div>
                  <div v-else>
                    <b style="color: #990000;">Non habilité</b><br>
                    <!-- <span class="">{{ props.row.nom ? props.row.nom.toUpperCase() + ' ' + props.row.prenom : 'n.d' }}</span> -->
                  </div>
                  <div slot="status" slot-scope="props" v-html="getInfosStatus(props.row)"></div>
                  <div slot="statut_controle" slot-scope="props">
                    <span class="">{{ props.row.statut_controle ? props.row.statut_controle : 'n.d' }}</span>
                  </div>
                  <div slot="affectation_controle" slot-scope="props">
                    <span
                      class="">{{ props.row.nom_affecte ? props.row.nom_affecte.toUpperCase() + ' ' + props.row.prenom_affecte : 'n.d'
                      }}</span>
                  </div>
                  <div slot="action" slot-scope="props">
                    <i v-if="getUser().id === currentCampagne.createur_id" class="fa fa-trash clickable text-danger" @click="initSupprimerDossier(props.row)"></i>
                  </div>
                  <div slot="selection" slot-scope="props">
                    <b-form-checkbox v-model="selectedRows" :value="props.row.id"
                                     :state="errors.checkbox === ''"></b-form-checkbox>
                  </div>
                  <div slot="h__selection">
                    <b-form-checkbox
                      v-model="allSelected"
                      :indeterminate="indeterminate"
                      aria-describedby="items"
                      aria-controls="items"
                      @change="toggleAll">
                    </b-form-checkbox>
                  </div>
                </v-server-table>
                <div slot="afterTable">
                  <div style="margin-bottom: 10px; justify-content: space-between;">
                    <b-button class="mr-1" type="enter" size="md" variant="primary"
                              @click.prevent="redirectToAttachDossier">
                      Attacher par critères
                    </b-button>
                    <b-button type="button" size="md" @click.prevent="openAttachNumDossierModal" variant="secondary">
                      Attacher par N° Dossier(s)
                    </b-button>
                    <b-button style="float: right;" class="float-right mb-1" type="enter" @click="lancerDetachement()"
                              size="md" variant="primary">
                      Détacher
                    </b-button>
                  </div>
                  <span class="field-error inline mr-1 float-right">{{ errors.checkbox }}</span>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
      </b-col>
    </b-row>
    <b-modal scrollable id="modal-attach-num-dossiers" ref="modal-attach-num-dossiers" title="Attacher dossier(s)">
      <div>
        <div class="col-md-12">
          <span> <i>Veuillez saisir les numéros des dossiers; seulement des chiffres; séparés par des virgules (,)</i> </span>
          <b-form-group style="margin-top: 10px;">
            <b-form-input type="text" placeholder="123456, 789012, 345678" id="num_dossiers"
                          v-model="num_dossiers"></b-form-input>
          </b-form-group>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeAttachNumDossierModal">Annuler</button>
          <button type="button" class="btn btn-primary" @click="validerAttachement">Valider</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider, getUser} from "@/utils/auth";
  import Multiselect from 'vue-multiselect';
  import {CoolSelect as AutoSelect} from 'vue-cool-select';
  import dossier_form_mixin from "../../../mixins/dossier-form-mixin";
  import controle_dossier_mixin from "../../../mixins/controle-dossier-mixin";
  import {isEmpty} from "@/utils/fileHelper";
  import { hasRule, rules as adminRules } from "@/utils/rulesHelper";
  import {canSeeCritere} from "@/utils/communHelper";

  export default {
    name: "Detail",
    mixins: [dossier_form_mixin, controle_dossier_mixin],
    components: {
      Multiselect,
      AutoSelect,
    },
    data() {
      let self = this;
      return {
        canSeeCritere,
        getUser,
        currentCampagne: {},
        id: '',
        noSearch: 'noSearch',
        libelle: '',
        type_controle: '',
        motif_op: '',
        echantillonAnnuel: '',
        frequence: '',
        demandeur: '',
        descriptif: '',
        typesControle: [],
        motifsControle: [],
        date_du: '',
        date_au: '',
        regleCumul: '',
        allRegleCumulOption: [],
        flagOptionsWithAdmin:[],
        nbDossierNir: 0,
        exclureBpij : false,
        num_dossiers: "",
        gestionnaire: '',
        gestionnaire_affecte: '',
        equipes: '',
        allEquipesOption: [],
		    exclureGroupeSiren: false,
        dateTraitement: '',
        traitementStatusId: '',
        traitementId: '',
        displayDateSinistre: true,
        date_sinistre_du : '',
        date_sinistre_au : '',
        allTraitements : [],
        options: {
          headings: {
            'source': 'N° dossier\nCanal récept.',
            'date_reception': 'Date de\nréception',
            'dossier_type': 'Type dossier\nTraitement',
            'siren': 'SIREN\nRaison Sociale',
            'produit': 'Segment\nProduit',
            'nom': 'NIR\nNom Prénom',
            'nb_pj': 'Nb. pj\nIndication',
            'status': 'Statut\nSous-statut',
            'statut_controle': 'Statut\nContrôle',
            'affectation_controle': 'Affectation\nContrôle',
            'action': '#',
            'selection': ''
          },
          columnsClasses: {
            nb_pj: 'pre-formatted tooltip-cell position-r',
            dossier_type: 'pre-formatted tooltip-cell sort-top position-r',
            siren: 'pre-formatted sort-top position-r',
            produit: 'pre-formatted sort-bottom position-r',
            nom: 'pre-formatted sort-bottom min-width-nir position-r',
            delai: 'pre-formatted position-r',
            status: 'pre-formatted position-r',
            statut_controle: 'pre-formatted sort-top position-r',
            affectation_controle: 'pre-formatted sort-top position-r',
            source: 'pre-formatted sort-top position-r',
            date_reception: 'pre-formatted align-middle sort-middle position-r',
            action: 'align-middle action-xs text-center position-r',
            selection: 'align-middle text-center position-r',
          },
          // rowClassCallback(row) {
          //   return 'row_dossier_' + row.id;
          // },
          rowClassCallback(row) {
            if (!self.getHabilitation(row)) {
              return "dossier-campagne-desactive" // #dcdcdc
            }
          },
          sortable: ['source', 'date_reception', 'dossier_type', 'siren', 'produit', 'nom'],
          filterable: false,
          resizableColumns: true,
          perPage: 25,
          perPageValues: [25, 50, 75, 100],
          orderBy: {column: 'date_reception', ascending: true},
          requestFunction: function (data) {
            self.url = '/espaceQualite/campagnes/attachedDossiers/' + self.$route.params.id;
            if (self.noSearch !== 'noSearch') {
              self.$store.commit('IS_LOADING', true);
            }
            return axios.get(self.url)
              .then(function (response) {
                if (self.noSearch !== 'noSearch') {
                  self.$store.commit('IS_LOADING', false);
                }
                self.findDossiers = response.data.data;
                return response;
              })
              .catch(function (e) {
                self.$store.commit('IS_LOADING', false);
                self.displayErrorModal('Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI');
              }.bind(this));
          },
        },
        columns: ['source', 'date_reception', 'dossier_type', 'siren', 'produit', 'nom', 'status', 'statut_controle', 'affectation_controle', 'action', 'selection'],
        items: [],
        url: '',
        allSelected: [],
        selectedRows: [],
        indeterminate: false,
        errors: {
          checkbox: ''
        },
        stats: {
          nbr_dossiers: 0,
          nbr_dossiers_a_affecter: 0,
          nbr_dossiers_en_cours: 0,
          nbr_dossiers_traites: 0,
          nbr_dossiers_abandonnes: 0,
          nbr_dossiers_ok: 0,
          nbr_dossiers_ko: 0,
        },
        statusCriteres: [],
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.id = this.$route.params.id;
      this.noSearch = true;
      this.getCampagne();
      this.getStats();
    },
    mounted() {
      this.getTypesControle()
      this.getMotifsControle()
      this.getReglesCumul()
      this.getEquipes()
      this.getHabilitation()
      this.manageDisplayDateSinistre()
    },
    watch: {
      allStatus: function () {
        if (this.allStatus) {
          this.setStatusCriteres();
        }
      },
      /*traitementId: function(){
        this.displayDateSinistre = false;
        if(this.traitementId){
          let traitementDeces = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_dc');
          let traitementInval = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_inval');
          let traitementIj = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_gestion_prestation');
          let traitementIjModulePrev = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_module_prevoyance');

          if(this.traitementId === traitementDeces.id 
            || this.traitementId === traitementInval.id 
            || this.traitementId === traitementIj.id 
            || this.traitementId === traitementIjModulePrev.id){
            this.displayDateSinistre = true;
          }else{
            this.date_sinistre_du = '';
            this.date_sinistre_au = '';
          }
        }
      },*/
    },
    methods: {
      onLoaded() {
        this.$store.commit('IS_LOADING', false);
      },
      manageDisplayDateSinistre(){
        if(this.traitementId){
          let traitementDeces = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_dc');
          let traitementInval = this.allTraitements.find(traitement => traitement.libelle_technique === 'gestion_inval');
          let traitementIj = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_gestion_prestation');
          let traitementIjModulePrev = this.allTraitements.find(traitement => traitement.libelle_technique === 'ij_module_prevoyance');

          if(this.traitementId === traitementDeces.id 
            || this.traitementId === traitementInval.id 
            || this.traitementId === traitementIj.id 
            || this.traitementId === traitementIjModulePrev.id){
            this.displayDateSinistre = true;
          }else{
            this.date_sinistre_du = '';
            this.date_sinistre_au = '';
          }
        }

        
      },
      getHabilitation(data) {
        let hasHabilitation = false
        let user = getUser();
        if (data !== undefined) {
          let userOags = user.profil_active[0].oags.map(oag => oag.code);
          let userOaps = user.profil_active[0].oaps.map(oap => oap.code);
          if (userOags.indexOf(data.oag) > -1 && userOaps.indexOf(data.oap) > -1) {
            hasHabilitation = true
          }
        }
        return hasHabilitation
      },
      getCampagne() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceQualite/campagnes/details/" + this.id)
          .then(response => {
            this.currentCampagne = response.data.campagne;
            this.libelle = response.data.campagne.libelle;
            this.date_du = response.data.campagne.date_debut;
            this.date_au = response.data.campagne.date_fin;
            this.type_controle = response.data.campagne.type_controle_id;
            this.motif_op = response.data.campagne.motif_controle_id;
            this.echantillonAnnuel = response.data.campagne.echantillon_annuel;
            this.frequence = response.data.campagne.frequence;
            this.demandeur = response.data.campagne.demandeur;
            this.siren = response.data.campagne.siren;
            this.nir = response.data.campagne.nir;
            this.idpp = response.data.campagne.criteres.id_pp;
            this.descriptif = response.data.campagne.descriptif;
            this.traitementId = response.data.campagne.traitement_id;
            this.date_sinistre_du = response.data.campagne.criteres['date_sinistre_du'];
            this.date_sinistre_au = response.data.campagne.criteres['date_sinistre_au'];
            this.dateTraitement = response.data.campagne.criteres['dateTraitement'];
            this.traitementStatusId = response.data.campagne.criteres['traitementStatusId']
            this.gestionnaire = response.data.valideur ? response.data.valideur.prenom + ' ' +response.data.valideur.nom : ''
            this.gestionnaire_affecte = response.data.gestionnaire_affecte ? response.data.gestionnaire_affecte.prenom + ' ' +response.data.gestionnaire_affecte.nom : ''
            this.statusCriteres = response.data.campagne.criteres['statusId'];

            this.exclureBpij = !isEmpty(response.data.campagne.criteres['exclureBpij']) ? true : false;
			      this.exclureGroupeSiren = !isEmpty(response.data.campagne.criteres['exclureGroupeSiren']) ? true : false;
            this.regleCumul = response.data.campagne.criteres['regleCumul'];
            this.nbDossierNir = response.data.campagne.criteres['nbDossierNir'];
            this.equipes = response.data.campagne.criteres['equipes'];
            this.setCriteresFields(response.data.campagne.criteres);
            this.$store.commit('IS_LOADING', false);
          })
          .catch((error) => {
            this.$store.commit('IS_LOADING', false);
            if (error.response && error.response.status === 404 && self != undefined) {
              this.displayWarningModal(`La campagne avec l'id ${this.id} n'existe pas`);
              this.$router.push({path: '/espace-qualite/campagnes'})
            }
          });
      },
      openAttachNumDossierModal() {
        this.$refs['modal-attach-num-dossiers'].show();
      },
      closeAttachNumDossierModal() {
        this.$refs['modal-attach-num-dossiers'].hide();
      },
      redirectToAttachDossier() {
        this.$router.push({path: '/espace-qualite/campagnes/attacher-dossiers/' + this.id});
      },
      validerAttachement() {
        let ids = this.num_dossiers.replace(/\s/g, '').split(',');
        ids = [...new Set(ids)];
        ids = ids.filter((value) => {
          return (value !== '' && value !== ' ' && value !== undefined && value !== null);
        });
        let filtered = ids.filter(function (el) {
          return /^\d+$/.test(el);
        });
        if (ids.length === filtered.length) {
          let self = this;
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post("/espaceQualite/campagnes/attachDossiers/" + this.id, {'dossiers': filtered})
            .then(response => {
              this.getStats();
              this.selectedRows = [];
              this.closeAttachNumDossierModal();
              this.$refs['attached_dossiers_table'].refresh();
              this.$swal({
                position: "top",
                type: "success",
                title: "Succès !",
                text: "Campagne a été attachée aux dossiers avec succès",
                showConfirmButton: false,
                timer: 5000
              });
            })
            .catch((error) => {
              this.selectedRows = [];
              this.$store.commit('IS_LOADING', false);
              let errorText = "Une erreur est survenue, lors de la suppression du type. Si le problème persiste, merci de faire un ticket au support DOSI.";
              if (error.response && error.response.status === 406) {
                errorText = error.response.data.message;
              }
              self.displayErrorModal(errorText);
            });
        } else {
          this.displayWarningModal("Le format saisie est incorrect");
        }
      },
      lancerDetachement() {
        if (this.validateCheckedCheckbox()) {
          this.$store.commit("IS_LOADING", true);
          this.$axios
            .post("/espaceQualite/campagnes/detachDossiers/" + this.id, {'dossiers': this.selectedRows})
            .then((result) => {
              this.getStats();
              this.selectedRows = [];
              this.$store.commit("IS_LOADING", false);
              this.$refs['attached_dossiers_table'].refresh();
              this.$swal({
                position: "top",
                type: "success",
                title: "Détachement avec succès",
                text: "Les dossiers ont été bien détachés",
                showConfirmButton: false,
                timer: 4000
              });
            })
            .catch((error) => {
              let errorText = "";
              this.$store.commit("IS_LOADING", false);
              if (error.response && error.response.status === 406) {
                errorText = error.response.data.message;
              } else {
                errorText = "Une erreur est survenue, lors du détachement des dossiers. Si le problème persiste, merci de faire un ticket au support DOSI.";
              }
              this.displayErrorModal(errorText);
            });
        } else {
          this.displayErrorModal("Vous devez d'abord sélectionner un ou plusieurs dossiers avant de pouvoir faire un attachement");
        }
      },
      validateCheckedCheckbox() {
        let error = false;
        this.errors.checkbox = '';
        if (this.selectedRows.length === 0) {
          error = true;
          this.errors.checkbox = 'Vous devez choisir au moins un dossier.';
        }
        return !error
      },
      toggleAll(checked) {
        this.selectedRows = checked ? this.$refs['attached_dossiers_table'].data.map(item => {
          return item.id
        }) : []
      },
      getStats() {
        // this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceQualite/campagnes/stats/" + this.id)
          .then(response => {
            // this.$store.commit('IS_LOADING', false);
            this.stats.nbr_dossiers = response.data.data.nbr_dossiers;
            this.stats.nbr_dossiers_a_affecter = response.data.data.nbr_dossiers_a_affecter;
            this.stats.nbr_dossiers_en_cours = response.data.data.nbr_dossiers_en_cours;
            this.stats.nbr_dossiers_traites = response.data.data.nbr_dossiers_traites;
            this.stats.nbr_dossiers_abandonnes = response.data.data.nbr_dossiers_abandonnes;
            this.stats.nbr_dossiers_ok = response.data.data.nbr_dossiers_ok;
            this.stats.nbr_dossiers_ko = response.data.data.nbr_dossiers_ko;
          })
          .catch(() => {
            // this.$store.commit('IS_LOADING', false);
            this.displayErrorModal('Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI');
          });

      },
      repartitionMotifsNonConforme() {
        this.$router.push({path: '/espace-qualite/campagnes/motifs-non-conforme/' + this.id});
      },
      NbrDossiersEnAnomalieParCollaborateur() {
        this.$router.push({path: '/espace-qualite/campagnes/rapport-collaborateur/' + this.id});
      },
      // populateFlagsForDetail(){
      //   console.log('allFlags2',this.allFlags);
      //   for (let flag of this.allFlags) {
      //       this.flagOptionsWithAdmin.push({code: flag.id, name: flag.libelle});
      //     }
      //   this.flag = [];
      //     for (let id of this.selectedFlags) {

      //       let name = "";

      //       for (let element of this.flagOptionsWithAdmin) {
      //         if (element.code === id) {
      //           name = element.name
      //         }
      //       }
      //       this.flag.push({code: id, name: name});
      //     }

          
      // },
      setCriteresFields(criteres) {
        if (criteres['flag'].length > 0) {
          this.selectedFlags = criteres['flag'];
          this.populateFlag();
        }
        if (criteres['produit'].length > 0) {
          this.selectedProduits = criteres['produit'];
          this.populateProduit();
        }
        if (criteres['segment'].length > 0) {
          this.selectedSegments = criteres['segment'];
          this.populateSegment();
        }
        if (criteres['canal'].length > 0) {
          this.selectedCanals = criteres['canal'];
          this.populateCanal();
        }
        if (criteres['type'].length > 0) {
          this.selectedTypes = criteres['type'];
          this.populateType();
        }
        if (criteres['group_siren'].length > 0) {
          this.selectedGroupSirens = criteres['group_siren'];
          this.populateGroupSiren();
        }
        if (criteres['status_prestij'].length > 0) {
          this.selectedStatusPrestij = criteres['status_prestij'];
          this.populateStatusPrestij();
        }
        if (criteres['segment_commercial'].length > 0) {
          this.selectedSegmentsCommerciaux = criteres['segment_commercial'];
          this.populateSegmentCommerciaux();
        }
        if (criteres['delegation'].length > 0) {
          this.selectedDelegations = criteres['delegation'];
          this.populateDelegation();
        }
        if (criteres['oags'].length > 0) {
          this.selectedOags = criteres['oags'];
          this.populateOags();
        }
        if (criteres['oaps'].length > 0) {
          this.selectedOaps = criteres['oaps'];
          this.populateOaps();
        }
        // if (criteres['equipes'].length > 0) {
        //   this.selectedEquipes = criteres['equipes'];
        //   this.populateEquipes();
        // }
        if (criteres['typeUrgence'].length > 0) {
          this.selectedTypesUrgences = criteres['typeUrgence'];
          this.populateTypeUrgence();
        }
      
        /*if (criteres['flag'].length > 0) {
          this.selectedFlags = criteres['flag'].map(item => item.code);


          this.populateFlagsForDetail();
        }*/
      },
      setStatusCriteres() {
        let statusCriteres = [];
        let sousStatusCriteres = [];
        let foundStatus = []
        if (this.statusCriteres.length > 0) {
          for (let statusId of this.statusCriteres) {
            foundStatus = _.find(this.allStatus, { 'id': parseInt(statusId) });

            if (!isEmpty(foundStatus)) {
              if (isEmpty(foundStatus.parent_id)) {
                statusCriteres.push(parseInt(statusId));
              } else {
                sousStatusCriteres.push(parseInt(statusId));
              }
            }
          }
          this.selectedStatus = statusCriteres;
          this.populateStatus();
          this.getSousStatus();
          this.selectedSousStatus = sousStatusCriteres;
          this.populateSousStatus();
        }

      },
      getTypesControle(){
        // this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceQualite/types_controles")
          .then(response => {
            for (let item of response.data.data) {
              this.typesControle.push({value: item.id, text: item.libelle})
            }
            // this.$store.commit('IS_LOADING', false);
          })
          .catch((error) => {
            this.handleErrors();
          });
      },
      getMotifsControle(){
        // this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceQualite/motifs_controles")
          .then(response => {
            for (let item of response.data.data) {
              this.motifsControle.push({value: item.id, text: item.libelle})
            }
            // this.$store.commit('IS_LOADING', false);
          })
          .catch((error) => {
            this.handleErrors();
          });
      },
      initSupprimerDossier(dossier) {
        // console.log('dossier',dossier)
        let text = 'Etes vous sûr de vouloir supprimer ce dossier de la campagne ?';
        let controle = dossier.controles.find(ctrl => ctrl.campagne_id === this.currentCampagne.id);
        if (!isEmpty(controle)) {
          let statusControle = controle.status;
          if (!isEmpty(statusControle)) {
            if (statusControle.libelle_technique === 'controle_termine') {
              text = 'Ce dossier est au statut "Contrôlé" êtes vous sûr de vouloir le supprimer ?';
            } else if (!isEmpty(controle.gestionnaire_qualite_id)) {
              text = 'Ce dossier est déjà affecté à un expert, êtes vous sûr de vouloir le supprimer ?';
            }
          } else if (!isEmpty(controle.gestionnaire_qualite_id)) {
            text = 'Ce dossier est déjà affecté à un expert, êtes vous sûr de vouloir le supprimer ?';
          }
        }

        this.confirmationSuppression(dossier, text);
      },
      confirmationSuppression(dossier, text) {
        this.$swal.fire({
            title: 'Êtes-vous sûr?',
            text: text,
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor:"#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          }).then((result) => {
            if (result.value !== true) {
              this.supprimerDossier(dossier);
            }
          })
      },
      getEquipes() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getEquipes")
          .then(response => {
            this.allEquipe = response.data.equipes;
            for (let equipe of response.data.equipes) {
              this.allEquipesOption.push({value: equipe.id, text: equipe.libelle});
            }
          })
          .catch(() => {
            self.handleErrors(self);
          });
      },
      getReglesCumul() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getReglesCumul")
          .then(response => {
            this.allRegleCumul = response.data.data;
            this.allRegleCumulOption.push({value: 'tous', text: 'Toutes les règles de cumul'});
            for (let regleCumul of response.data.data) {
              this.allRegleCumulOption.push({value: regleCumul.libelle_technique, text: regleCumul.libelle});
            }
          })
          .catch(() => {
            self.handleErrors(self);
          });
      },
      displayNbDossierNir() {
        if(this.nbDossierNir === 0 || this.nbDossierNir == 0){
          return "Tous";
        }else if(this.nbDossierNir == 5){
          return '1 seul';
        }else if(this.nbDossierNir == 10){
          return '2 à 5';
        }else if(this.nbDossierNir == 15){
          return '2 et +';
        }else{
          return (this.nbDossierNir -15)  + ' et +';
        }
      },
      supprimerDossier(dossier) {
        let self = this;
        let data = {
          campagneId: this.currentCampagne.id,
          dossierId: dossier.id
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post("/espaceQualite/campagnes/deleteDossier",data)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.$refs.attached_dossiers_table.refresh();
            this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le dossier a bien été supprimé de la campagne',showConfirmButton: false, timer: 3000})
          })
          .catch(function(error){
            console.log(error)
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression du dossier de la campagne. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
          })
      },
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
